import axios from 'axios'
import { Buffer } from 'buffer'
import config from '../../config/local-config'
import apiConfig from '../../config/api-config'
import GTM from './GTM'

const { registrationFail, blueshiftSubscribe } = GTM

const version = 'v1'
const serviceName = 'accounts'
const opt = 'add-account'
const apiUrl = `${apiConfig.apiURL}/${version}/${serviceName}/${opt}/`

const Register = registerInfo => {
  let password = registerInfo && registerInfo.password
  password = password.toString().replace('&', '%26')
  password = Buffer.from(password).toString('base64')
  const body = {
    username: registerInfo && registerInfo.emailAddress.trim(),
    first_name: registerInfo && registerInfo.firstName.trim(),
    last_name: registerInfo && registerInfo.lastName.trim(),
    password,
    email: registerInfo && registerInfo.emailAddress,
    domain: config.hydra.site,
    'g-recaptcha-response': registerInfo.captcha,
    ltr: registerInfo && registerInfo.ltrPromo,
    "isInvRecaptchaEnabled": registerInfo.isInvRecaptchaEnabled,
    ...registerInfo?.enrollToLoyalty ? { enroll_to_loyalty: registerInfo?.enrollToLoyalty } : {},
  }
  return axios.post(apiUrl, body, {
    headers: {
      apikey: apiConfig.apiKey,
    },
  })
}

const CreateAccount = registerInfo => new Promise((resolve, reject) => {
  Register(registerInfo)
    .then(resp => {
      if (resp) {
        resolve(resp)
        blueshiftSubscribe(registerInfo, !registerInfo.promotionalEmail)
      } else {
        registrationFail('Failed to receive response while registering.')
      }
    })
    .catch(err => {
      registrationFail('Network error.')
      if (err.response && err.response.data) reject(err.response.data)
      else reject(err)
    })
})

export default CreateAccount
